/**
 * Release 27 removed photo reading. What it kept in the browser's own storage goes at every
 * launch (removing an absent key costs nothing): the list of document types with a button
 * (localStorage) and a certificate handed to Mode Salin Buku and never opened (this tab's
 * sessionStorage, which outlives a reload). The OPFS folders and the database rows are the
 * worker's (../db/sisaBaca). Never throws: a storage that refuses held nothing either.
 */

// Legacy storage names from SIMU, as the old reading wrote them.
const KUNCI_JENIS = 'simu:baca:jenis'
const AWALAN_ISIAN_BUKU = 'simu:baca:isian-buku:'

/** The part of the Web Storage API used here, so this module needs no DOM types. */
export interface PenyimpananSapu {
  readonly length: number
  key(indeks: number): string | null
  removeItem(kunci: string): void
}

function ambil(nama: 'localStorage' | 'sessionStorage'): PenyimpananSapu | undefined {
  try {
    return (globalThis as Partial<Record<typeof nama, PenyimpananSapu>>)[nama]
  } catch {
    return undefined
  }
}

function sapu(s: PenyimpananSapu | undefined, cocok: (kunci: string) => boolean): void {
  if (s === undefined) return
  try {
    const kunci: string[] = []
    for (let i = 0; i < s.length; i += 1) {
      const k = s.key(i)
      if (k !== null && cocok(k)) kunci.push(k)
    }
    for (const k of kunci) s.removeItem(k)
  } catch {
    // Storage refused: nothing was kept there either.
  }
}

export function sapuSisaBacaPeramban(
  local: PenyimpananSapu | undefined = ambil('localStorage'),
  sesi: PenyimpananSapu | undefined = ambil('sessionStorage'),
): void {
  sapu(local, (k) => k === KUNCI_JENIS)
  sapu(sesi, (k) => k.startsWith(AWALAN_ISIAN_BUKU))
}
